export default __webpack_public_path__ + "static/media/llm-loader.f17a8147.gif";